import type { UserRole } from "@usales/contract/values";

export type Workspace = "sales" | "mgr";
interface Account { tenantId: string; userId: string; role: UserRole }
interface PreferenceStorage { getItem(key: string): string | null; setItem(key: string, value: string): void }
type StorageSource = () => PreferenceStorage;
const keyFor = (account: Account): string => `usales:workspace:v1:${account.tenantId}:${account.userId}`;

/** Tab choice takes priority, so sales and management tabs can coexist. Role permissions remain authoritative. */
export function readWorkspace(account: Account, stores: readonly StorageSource[]): Workspace {
  if (account.role !== "admin") return account.role === "sales" ? "sales" : "mgr";
  for (const storage of stores) {
    try {
      const value = storage().getItem(keyFor(account));
      if (value === "sales" || value === "mgr") return value;
    } catch { /* Continue with the next store when browser storage is unavailable. */ }
  }
  return "mgr";
}

export function rememberWorkspace(account: Account, workspace: Workspace, stores: readonly StorageSource[]): void {
  if (account.role !== "admin") return;
  for (const storage of stores) {
    try { storage().setItem(keyFor(account), workspace); }
    catch { /* Switching still works in memory when persistence is unavailable. */ }
  }
}
